
<template>
  <div>
    <el-card class="box-card">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="名称" prop="name" class="form-bottom">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="手机号" prop="name" class="form-bottom">
              <el-input
                v-model="searchForm.mobile"
                placeholder="请输入手机号"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="类型" prop="type" class="form-bottom">
              <el-select clearable v-model="searchForm.type" placeholder="请选择类型">
                <el-option
                  v-for="item in typeList"
                  :key="item.remark"
                  :label="item.name"
                  :value="item.remark"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-button type="primary" @click="pageList" icon="el-icon-search"
          >查询</el-button
          >
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="姓名" width="200"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="200"></el-table-column>
        <el-table-column prop="type" label="状态" width="200">
          <template slot-scope="row">
            <div v-for="item in typeList">
              <span v-if="item.remark == row.row.type">{{item.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注信息"></el-table-column>

        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" v-auth="'/agentLevel/updateAgentLevel'">
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="changeEditFormVisible(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>


    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="400px"
      left
    >
      <el-form
        ref="agentTouristInfo"
        :model="agentTouristInfo"
        :label-width="formLabelWidth"
      >

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型">
            <el-select clearable v-model="agentTouristInfo.type" placeholder="请选择类型">
              <el-option
                v-for="item in typeList"
                :key="item.remark"
                :label="item.name"
                :value="item.remark"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="agentTouristInfo.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        page: {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: ""
        },
        searchForm: {},
        loading: true,
        editFormVisible: false,
        formLabelWidth: "60px",
        agentTouristInfo: {},
        typeList: []
      };
    },
    methods: {
      changeEditFormVisible(id) {
        this.getAgentTouristInfo(id);
        this.editFormVisible = true;
      },
      getAgentTouristInfo(id) {
        this.api.agentTouristInfo
          .getAgentTouristInfo({id: id})
          .then(result => {
            this.agentTouristInfo = result.data
          })
      },
      update() {
        this.api.agentTouristInfo.updateAgentTouristInfo(this.agentTouristInfo).then(res => {
          if(res.success) {
            this.editFormVisible = false;
            this.pageList();
            this.$message.success(res.message);
          } else {
            this.$message.success(res.message);
          }
        })
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.pageList();
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber;
        this.pageList();
      },
      // 获取数据类型
      getDictionaryList() {
        this.api.dictionary.getDictionaryListByParentId({parentId: "1542061369920487425"}).then(res => {
          if(res.success) {
            this.typeList = res.data;
          }
        })
      },
      // 获取列表数据
      pageList() {
        this.searchForm.pageSize = this.page.pageSize;
        this.searchForm.pageNumber = this.page.pageNumber;
        this.api.agentTouristInfo
          .pageList(this.searchForm)
          .then(result => {
            this.page.rows = result.data.records;
            this.page.total = result.data.total;
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
          });
      },
      reset() {
        this.$refs.searchForm.resetFields();
        this.page = {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: ""
        };
        this.pageList();
      },
    },
    mounted () {
      // 获取数据类型
      this.getDictionaryList();
      this.pageList();
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/agentInfoApply/index.vue